<section class="members-table mt-3"
  [class.view-only]="viewOnly">
  <div class="members-table__source"
    *ngIf="!viewOnly || !disabled">
    <h4 class="my-3">{{ 'DISTRIBUTE.members' | translate }}</h4>
    <mat-selection-list *ngIf="source$ | async as members"
      class="members-table__list"
      #sourceTeam
      [compareWith]="compareMembers"
      [disabled]="disabled"
      [(ngModel)]="selectedSourceList">
      <mat-list-option *ngFor="let member of members; odd as odd; trackBy: trackByFn"
        checkboxPosition="before"
        [class.odd]="odd"
        [disableRipple]="true"
        [value]="member">
        <span>
          {{ member?.reviewer | getMemberName }}
        </span>
        <mat-divider [inset]="true"></mat-divider>
      </mat-list-option>
    </mat-selection-list>
  </div>
  <div class="members-table_actions"
    fxLayout="column"
    fxLayoutAlign="center"
    *ngIf="!viewOnly || !disabled">
    <button mat-icon-button
      (click)="removeAll()"

      [disabled]="(target$ | async).length == 0 || disabled">
      <i class="fa fa-angle-double-right"
        aria-hidden="true"></i>
    </button>
    <button mat-icon-button
      (click)="remove()"
      [disabled]="selectedTargetList.length == 0 || disabled">
      <i class="fa fa-angle-right"
        aria-hidden="true"></i>
    </button>
    <button mat-icon-button
      (click)="add()"
      [disabled]="selectedSourceList.length == 0 || disabled">
      <i class="fa fa-angle-left"
        aria-hidden="true"></i>
    </button>
    <button mat-icon-button
      (click)="addAll()"
      [disabled]="(source$ | async).length == 0 || disabled">
      <i class="fa fa-angle-double-left"
        aria-hidden="true"></i>
    </button>
  </div>
  <div class="members-table__target">
    <h4 class="my-3">{{ 'DISTRIBUTE.addMembers' | translate }}</h4>

    <ng-container *ngIf="target$ | async as addedMembers">
      <mat-selection-list class="members-table__list"
        *ngIf="!viewOnly"
        #targetTeam
        [compareWith]="compareMembers"
        [(ngModel)]="selectedTargetList"
        [disabled]="disabled">
        <mat-list-option *ngFor="let member of addedMembers; odd as odd; trackBy: trackByFn"
          checkboxPosition="before"
          [class.odd]="odd"
          [disableRipple]="true"
          [value]="member">
          <span>
            {{ member?.reviewer | getMemberName }}
          </span>
          <mat-divider [inset]="true"></mat-divider>
        </mat-list-option>
      </mat-selection-list>
      <mat-list class="members-table__list"
        *ngIf="viewOnly">
        <mat-list-item *ngFor="let member of addedMembers; odd as odd; trackBy: trackByFn">{{ member?.reviewer |
          getMemberName }} <mat-divider [inset]="true"></mat-divider></mat-list-item>

      </mat-list>
    </ng-container>
  </div>
</section>
